import type {} from "@lit/react";
import { Breadcrumbs as BreadcrumbsElement, } from "@vaadin/breadcrumbs/vaadin-breadcrumbs.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { BreadcrumbsElement, };
export type BreadcrumbsEventMap = Readonly<{}>;
const events = {} as BreadcrumbsEventMap;
export type BreadcrumbsProps = WebComponentProps<BreadcrumbsElement, BreadcrumbsEventMap>;
export const Breadcrumbs = createComponent({
    elementClass: BreadcrumbsElement, events, react: React, tagName: "vaadin-breadcrumbs"
});
